export default {
  init() {

  },
  finalize() {
    // @see {https://codepen.io/maheshwaghmare/pen/ExmXwam}
    let timeline = document.querySelector('.timeline');
    let marker = timeline.querySelector('.marker');
    let markerDate = timeline.querySelector('.marker .date');
    let markerDateTimeout = null;
    let sections = document.querySelectorAll('.section');
    let currentSectionEl = null;

    document.addEventListener('scroll', function () {
      let parentTop = timeline.getBoundingClientRect().top || 0;
      let crossChildHeight = 0;

      if (marker.clientHeight > timeline.getBoundingClientRect().bottom) {
        crossChildHeight = timeline.getBoundingClientRect().bottom - marker.clientHeight;
      }

      if (parseInt(crossChildHeight) < 0) {
        marker.classList.remove('start');
        marker.classList.remove('fixed');
        marker.classList.add('end');
      } else {
        if (parentTop <= crossChildHeight) {
          marker.classList.remove('start');
          marker.classList.remove('end');
          marker.classList.add('fixed');
        } else {
          marker.classList.remove('fixed');
          marker.classList.remove('end');
          marker.classList.add('start');
        }
      }

      let closestSection = null;

      sections.forEach(function (el) {
        if (marker.getBoundingClientRect().y > el.getBoundingClientRect().top) {
          let sectionDist = marker.getBoundingClientRect().y - el.getBoundingClientRect().top;
          if (closestSection === null || sectionDist < closestSection.dist) {
            closestSection = {
              el: el,
              dist: sectionDist,
            };
          }
        }
      });

      if (closestSection && closestSection.el != currentSectionEl) {
        markerDate.classList.add('hide');
        
        // Currently using setTimeout - this can be done better with GSAP if we have time but will use more resources just for one little animation...
        if (markerDateTimeout) {
          clearTimeout(markerDateTimeout);
          markerDateTimeout = null;
        }

        markerDateTimeout = setTimeout(function () {
          markerDate.innerHTML = closestSection.el.getAttribute('data-date-header');
          markerDate.classList.remove('hide');
        }, 250);  // Ensure this number matches the fade transition timer in the css
        currentSectionEl = closestSection.el;
      }
    });
  },
}



// WEBPACK FOOTER //
// ./scripts/routes/templateHistory.js